import axios from 'axios';
import qs from 'qs';
import { get } from 'lodash';

const EXAMS_LIST_LOAD = 'EXAMS_LIST_LOAD';
const EXAMS_LIST_SUCCESS = 'EXAMS_LIST_SUCCESS';
const EXAMS_LIST_FAILED = 'EXAMS_LIST_FAILED';
const EXAMS_SET_LOADING = 'EXAMS_SET_LOADING';

const EXAMS_FORM_LOAD = 'EXAMS_FORM_LOAD';
const EXAMS_FORM_SUCCESS = 'EXAMS_FORM_SUCCESS';
const EXAMS_FORM_FAILED = 'EXAMS_FORM_FAILED';

const EXAM_DELETE_LOAD = 'EXAM_DELETE_LOAD';
const EXAM_DELETE_SUCCESS = 'EXAM_DELETE_SUCCESS';
const EXAM_DELETE_FAILED = 'EXAM_DELETE_FAILED';

const EXAM_EDIT_LOAD = 'EXAM_EDIT_LOAD';
const EXAM_EDIT_SUCCESS = 'EXAM_EDIT_SUCCESS';
const EXAM_EDIT_FAILED = 'EXAM_EDIT_FAILED';

const EXAM_VIEW_LOAD = 'EXAM_VIEW_LOAD';
const EXAM_VIEW_SUCCESS = 'EXAM_VIEW_SUCCESS';
const EXAM_VIEW_FAILED = 'EXAM_VIEW_FAILED';

const EXAMS_RESET = 'EXAMS_RESET';
const EXAMS_RESET_FORM = 'EXAMS_RESET_FORM';

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit:process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: '',
  orderMode: 'ASC',
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EXAMS_RESET:
      return {
        ...initialState
      };
    case EXAMS_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case EXAM_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case EXAMS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case EXAM_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case EXAM_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case EXAMS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case EXAMS_FORM_FAILED:
    case EXAM_EDIT_FAILED:
    case EXAM_DELETE_FAILED:
    case EXAMS_LIST_FAILED:
    case EXAM_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case EXAMS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode
      };
      case EXAM_VIEW_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            failed: false,
            viewData: action.viewData,
            commentThread: action.commentThread || false,
            viewLoading: false
        };
    case EXAMS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case EXAM_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case EXAM_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case EXAMS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
}

export const reset = () => dispatch => {
  dispatch({
    type: EXAMS_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: EXAMS_RESET_FORM
  });
};

export const updateExams = (model,id,data) => dispatch => {
  dispatch({
    type: EXAM_EDIT_LOAD
  });

    let obj = {};
    obj[model] = data;

  return axios.put('/v1/exams/'+id, obj).then(
      () => dispatch({
        type: EXAM_EDIT_SUCCESS
      })
  ).catch(error => {
    dispatch({
      type: EXAM_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const viewExams = (id) => dispatch => {
    dispatch({
        type: EXAM_VIEW_LOAD
    });
    return axios.get('/v1/exams/'+id).then(
        response => dispatch({
            type: EXAM_VIEW_SUCCESS,
            viewData: get(response, 'data.data'),
            commentThread: get(response, 'data.commentThread', false)
        })
    ).catch(error => {
        dispatch({
            type: EXAM_VIEW_FAILED,
            message: get(error, 'response.data.message', null)
        })
    });
};

export const createExams = (model, data) => dispatch => {
  dispatch({
    type: EXAM_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios.post('/v1/exams', obj).then(response => dispatch({
    type: EXAM_EDIT_SUCCESS,
    id: get(response, 'data.data.id', null),
  })).catch(error => {
    dispatch({
      type: EXAM_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const examDelete = (id) => dispatch => {
  dispatch({
    type: EXAM_DELETE_LOAD
  });
  return axios.delete('/v1/exams/'+id)
      .then((response) => dispatch({
        type: EXAM_DELETE_SUCCESS,
        id
      })).catch(error => dispatch({
        type: EXAM_DELETE_FAILED,
        message: get(error, 'response.data.message', null)
      }));
};

export const setLoading = (loading) => dispatch => {
  dispatch({
    type: EXAMS_SET_LOADING,
    loading
  });
};

export const examsList = (page, keyword, sort, filters, perPage) => dispatch => {
  dispatch({
    type: EXAMS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    'per-page': perPage
  };

  params[filters.model] = filters.filters;

  return axios.get(
      '/v1/exams',
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
  ).then(response => {
    let sort = get(response, 'data.sort', null),
        mode = 'ASC';
    if(sort && sort.indexOf('-') !== -1) {
      mode = 'DESC';
      sort = sort.substr(1);
    }
    return dispatch({
      type: EXAMS_LIST_SUCCESS,
      data: get(response, 'data.data', null),
      page: get(response, 'data.page', 0),
      limit: get(response, 'data.per-page', 0),
      total: get(response, 'data.total', 0),
      order: sort,
      orderMode: mode
    });
  })
  .catch(error => dispatch({
    type: EXAMS_LIST_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};



// WEBPACK FOOTER //
// ./src/redux/modules/exams.js